import { Container, Spacer } from "@components/atoms";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import Loader from "@components/atoms/Loader";
import LayoutContainer from "@components/layout/LayoutContainer";
import AskSupplierModal from "@components/molecules/AskSupplier";
import CollapsibleView from "@components/molecules/CollapsibleView";
import { messageType } from "@components/molecules/PopUp/types";
import { useScrollContext } from "@navigations/utils/ScrollContext";
import {
  CommonActions,
  useIsFocused,
  useLinkTo,
  useNavigation,
} from "@react-navigation/native";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import {
  BulkRequestEnum,
  getProductPrefix,
  MediaType,
  ProductCategory,
} from "@utils/constants";
import { navigate } from "@navigations/utils/RootNavigation";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import {
  Dimensions,
  Keyboard,
  LayoutChangeEvent,
  Linking,
  NativeScrollEvent,
  NativeSyntheticEvent,
  Platform,
  useWindowDimensions,
  View,
} from "react-native";
import { useTheme } from "styled-components/native";
import styled, { DefaultTheme } from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import {
  useGetPdpSectionLayout,
  useGetReviewPageSectionsOrder,
} from "../../hooks/useGetSectionLayout";
import {
  CustomtOption,
  PdpSections,
  PdpComponentNames,
} from "@utils/customization";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import { usePdpLayout } from "@redux/slices/pdpLayoutSlice";
import { css } from "styled-components/native";
import {
  getHeaderStyleBasedOnProduct,
  getPriceModeColorCode,
  getProductThemeFromType,
} from "@components/common/Header/utils";
import {
  getBoxShadow,
  getButtonCategory,
  isDiamond,
  isDiamondOrLabGrown,
  isGemstone,
  isJewelry,
  isLabGrown,
  replaceDeeplinkScheme,
} from "@utils/product/productValidators";
import { useAddToCart, useCheckItemAvailability } from "@apis/cartRequest";
import { useAvailabilityData } from "../../hooks/useAvailabilityData";
import { useDispatch, useSelector } from "react-redux";
import useHideNavsOnScroll from "@navigations/utils/useHideNavsOnScroll";
import Animated from "react-native-reanimated";
import ConfirmationPopup from "@components/atoms/ConfirmationPopUp";
import { getProductProperty } from "@scenes/findMatch/Utils/ProductDetailList/utils";
import RenderHTML from "react-native-render-html";
import { useTypographyStore } from "@redux/slices/typographySlice";
import LineViewContainer from "@scenes/requests/utils/LineView";
import Breadcrumbs from "@components/molecules/Breadcrumbs/Breadcrumbs";
import Personalization from "../configurator/JewelryConfigurator/Personalization";
import { useJewelryConfiguratorState } from "@scenes/configurator/JewelryConfigurator/Context/JewelryConfiguratorContext";
import { FooterSpaceProps, Props } from "@scenes/pdp/types";
import PDPGalleryView from "@scenes/pdp/utils/PDPGalleryView";
import ProductDetailExpand from "@scenes/pdp/utils/ProductDetailExpand";
import ReviewHeaderDetails from "./components/ReviewHeaderDetail";
import StoneCard from "./components/StoneCard";
import StickyPriceContainer from "@scenes/pdp/utils/StickyPriceContainer";
import {
  filterCertificate,
  filterInvalidMedia,
  getComponentDimentions,
  getProductAlphaColor,
  getProductColor,
  useProductInfo,
} from "@scenes/pdp/utils/utils";
import SettingCard from "./components/SettingCard";
import PdpBottomButtons from "@scenes/pdp/utils/PdpBottomButtons";
import PDPBottomTotalPriceSection from "@scenes/pdp/utils/PDPBottomTotalPriceSection";
import BMHModal from "@components/molecules/BMH/SlideSheet";
import Routes from "@navigations/Routes";
import JewelryConfiguratorComponents from "@scenes/configurator/JewelryConfigurator";
import { RedirectFunc } from "@scenes/configurator/OrderCart/utils";
import { useNavigationHistory } from "../../hooks/useNavigationHistory";
import {
  resetFiltersPayload,
  useSearchFiltersPayload,
  useSearchFiltersSlice,
} from "@redux/slices/searchFilters";
import { getReviewPageButtons } from "./utils/utils";
import OptionsModal from "@scenes/pdp/utils/OptionsModal";
import {
  BreadCrumbLabel,
  NavigationHistoryState,
} from "@components/molecules/Breadcrumbs/utils";
import { useGetJewelryVariation } from "@apis/diamondDetail";
import { updateProductIdAtIndex } from "@redux/slices/navigationHistorySlice";
import PopUp from "@components/molecules/PopUp";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import PriceDisclaimer from "@scenes/pdp/utils/PriceDisclaimer";
import { ThreeDPropertiesProvider } from "../../contexts/ThreeDPropertiesContext";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { updateURL } from "@scenes/configurator/JewelryConfigurator/utils";
import { getVisibleReviewPageSections } from "@scenes/pdp/utils/pdpConfigurableComponent";

const ReviewPage = ({ route }: Props) => {
  const navigation = useNavigation();
  const [modals, setModals] = useState({
    showBMHModal: false,
    bmhPopUp: false,
    showAskSupplierModal: false,
    iFramePopUp: false,
    showLabgrownPopup: false,
    showSuccessPopup: false,
    showButtonsOptions: false,
    showRequestSuccessPopUp: false,
    showAddToCartSuccessPopUp: false,
  });
  const [requestData, setRequestData] = useState({});
  const { deviceWidth: width } = useIsFoldable();
  const { height } = useWindowDimensions();
  const [selectedTabSlideSheet, setSelectedTabSlideSheet] = useState("memo");
  const [isKeyboardVisible, setKeyboardVisible] = useState(false);
  const userInfo = useUserInfo();
  const [contentWidth, setContentWidth] = useState(0);
  const handleLayout = (e: LayoutChangeEvent) => {
    setContentWidth(theme.isMobile ? 375 : e.nativeEvent.layout.width);
  };
  const { history } = useSelector(
    (state: any) => state.navigationHistory as NavigationHistoryState
  );
  const isFirstBreadcrumbStoneDetailPage =
    history?.[0]?.params?.breadCrumbLabel === BreadCrumbLabel.STONE_DETAILS;
  const isFirstBreadcrumbJewelryDetailPage =
    history?.[0]?.params?.breadCrumbLabel === BreadCrumbLabel.SETTING_DETAILS;

  const startFromSetting = history?.[0]?.params?.productType === "jewelry";
  const startFromStone = history?.[0]?.params?.productType !== "jewelry";

  const linkTo = useLinkTo();
  const { clearRouteHistory } = useNavigationHistory();
  const dispatch = useDispatch();
  const headerProductView = useRef();
  const headerStickySummaryViewRef = useRef();
  const [showProductHeaderStickySummary, setShowProductHeaderStickySummary] =
    useState(false);
  const maxContentLength = 1432;
  const [bottomButtons, setBottomButtons] = useState<any[][]>([]);
  const [mediaActiveIndex, setMediaActiveIndex] = useState(0);
  const [stickyHeaderActiveIndex, setStickyHeaderActiveIndex] = useState(0);
  const [isMultilineFocused, setIsMultilineFocused] = useState(false);
  const priceMode =
    route?.params?.externalPriceMode === undefined
      ? userInfo.getUserPriceMode()
      : route?.params?.externalPriceMode;
  const product_type = route?.params?.productType as ProductCategory;
  const fromRequest = route?.params?.fromRequest;
  const fromOrderCart = route?.params?.fromOrderCart;
  const additionalAttributes = useMemo(
    () => JSON.parse(route?.params?.additionalAttributes || "{}"),
    [route?.params?.additionalAttributes]
  );
  const [_, handleReset] = useScrollContext();
  const isFocused = useIsFocused();
  const theme = useTheme();
  const typography = useTypographyStore();
  const pdpLayout = usePdpLayout();
  const isCustomApp = useSelector((state: any) => state.appState?.isCustomApp);
  const checkItemAvailability = useCheckItemAvailability();
  const showAvailabilityDot = useAvailabilityData(
    pdpLayout?.[product_type ?? ""]?.availabilty_price_modes ?? [
      PriceModes.GREEN,
      PriceModes.ORANGE,
      PriceModes.WHITE,
    ]
  );
  const { t, i18n } = useTranslation();

  const { jsScrollHandler } = useHideNavsOnScroll();
  const {
    itemDetail: mItemDetail,
    isAPILoading,
    allTypes,
    stoneItemDetail: mStoneItemDetail,
    jcSelectedOption,
    setPersonalization,
    setReviewTotalPrice,
    reviewTotalPrice,
    resetDefaultSlug,
    setItemDetail,
    setStoneItemDetail,
    setMatchingPairItemDetail,
    matchingPairItemDetail: mMatchingPairItemDetail,
    updateJewelryConfigInfo,
    userSelectedSlug,
    appendNewVariation,
    setUserSelectedSlug,
    updateJcSelectedOptions,
    getDynamicParams,
    setAllTypes,
  } = useJewelryConfiguratorState();

  const itemDetail = useMemo(
    () =>
      route?.params?.itemDetail ||
      (mItemDetail?.type !== ProductCategory.JEWELRY &&
      mItemDetail?.type !== ProductCategory.LABGROWN_JEWELRY
        ? mStoneItemDetail
        : mItemDetail),
    [
      mItemDetail?.type,
      mItemDetail?.stock_type,
      mStoneItemDetail?.id,
      mItemDetail?.id,
      route?.params?.itemDetail,
    ]
  );
  const stoneItemDetail = useMemo(
    () =>
      route?.params?.stoneItemDetail ||
      (mStoneItemDetail?.type === ProductCategory.JEWELRY ||
      mStoneItemDetail?.type === ProductCategory.LABGROWN_JEWELRY
        ? mItemDetail
        : mStoneItemDetail),
    [
      mStoneItemDetail?.type,
      mStoneItemDetail?.stock_type,
      mStoneItemDetail?.id,
      mItemDetail?.id,
      route?.params?.stoneItemDetail,
    ]
  );

  const matchingPairItemDetail = route?.params?.matchingPairItemDetail?.id
    ? route?.params?.matchingPairItemDetail
    : mMatchingPairItemDetail;
  const { enableJewelryBuilder } = useOrgSettingsSlice();
  const { min_max_Options } = useSearchFiltersSlice();
  const modifyShapeSupportForBuilder =
    min_max_Options?.supported_shapes?.length > 1 &&
    userInfo.user.feature_settings?.allow_search_modify_in_builder &&
    enableJewelryBuilder &&
    mStoneItemDetail?.type === ProductCategory.JEWELRY;
  const payload = useSearchFiltersPayload(stoneItemDetail?.type);
  const dynamicParams = useMemo(
    () =>
      getDynamicParams(
        jcSelectedOption.current.option_slug,
        jcSelectedOption.current.option_slug,
        true,
        payload
      ),
    [
      JSON.stringify(payload),
      JSON.stringify(jcSelectedOption.current.option_slug),
    ]
  );

  // Track the last processed variation data to avoid infinite loops
  const lastProcessedVariationIdRef = useRef<string | null>(null);
  // Track if we need to trigger a refetch due to language change
  const [languageRefetchPending, setLanguageRefetchPending] = useState(false);
  // Track the previous language to detect changes
  const prevLanguageRef = useRef(i18n.language);

  // Detect language change and set the refetch flag
  useEffect(() => {
    if (prevLanguageRef.current !== i18n.language) {
      prevLanguageRef.current = i18n.language;
      lastProcessedVariationIdRef.current = null;
      setLanguageRefetchPending(true);
    }
  }, [i18n.language]);

  // Determine if query should be enabled
  const shouldEnableForLanguage = languageRefetchPending && !!itemDetail?.id;
  const isVariationEnabled =
    modifyShapeSupportForBuilder || shouldEnableForLanguage;

  const {
    data: VariationData,
    isSuccess,
    isFetching: isLoading,
    isFetched,
  } = useGetJewelryVariation(
    itemDetail?.id as number,
    userInfo.getPriceMode(),
    userInfo.getFeatureSettings().variations_price_attachment ? 10 : 1,
    isVariationEnabled,
    dynamicParams,
    modifyShapeSupportForBuilder ? stoneItemDetail?.id : undefined,
    i18n.language
  );

  // Reset the language refetch flag once the fetch completes
  useEffect(() => {
    if (languageRefetchPending && !isLoading && isFetched) {
      setLanguageRefetchPending(false);
    }
  }, [languageRefetchPending, isLoading, isFetched]);

  useEffect(() => {
    if (VariationData !== undefined && (isSuccess || isFetched)) {
      const data = VariationData?.data?.response;
      const variations = data?.body?.variations;
      const variationItem = variations?.[0]?.item;

      if (!variations || variations.length === 0 || !variationItem) {
        return;
      }

      // Create a unique identifier for this variation data. Some products
      const variationKey = `${variationItem.id ?? "no-id"}-${i18n.language}`;

      // Skip if we've already processed this exact variation
      if (lastProcessedVariationIdRef.current === variationKey) {
        return;
      }

      // Mark as processed before making state changes
      lastProcessedVariationIdRef.current = variationKey;

      appendNewVariation(variations);
      setUserSelectedSlug(variationItem?.slug_detail ?? {});
      updateJcSelectedOptions(variationItem, true);
      setAllTypes(variationItem);
      if (
        mStoneItemDetail?.type === ProductCategory.JEWELRY &&
        Platform.OS === "web"
      ) {
        localStorage.setItem(
          "stoneItemDetails",
          JSON.stringify({
            ...variationItem,
            variation_required: true,
          })
        );
        updateURL(variationItem?.id);
      }
      if (mStoneItemDetail?.type === ProductCategory.JEWELRY) {
        setStoneItemDetail({
          ...variationItem,
          variation_required: true,
        });
      }
    }
  }, [VariationData, i18n.language]);

  useEffect(() => {
    if (isFetched && modifyShapeSupportForBuilder) {
      dispatch(
        updateProductIdAtIndex({
          index: 1,
          productID: VariationData?.data?.response.body.variations[0]?.item.id,
        })
      );
    }
  }, [isFetched]);

  const [galleryItemType, setGalleryItemType] = useState("setting");
  const toggleGalleryItem = (type: "stone" | "setting" | "matchingStone") => {
    if (type) {
      setGalleryItemType(type);
    }
  };

  const addToCart = useAddToCart(BulkRequestEnum.FromPdp);
  const showBulkRequest = userInfo?.showBulkRequestFeature(
    product_type,
    userInfo?.user?.price_mode
  );
  const showOrderCartButton = userInfo?.getShoppingCartButtonVisibility();
  const [rightComponentWidth, setRightComponentWidth] = useState(0);
  const { background } = getHeaderStyleBasedOnProduct(
    product_type as ProductCategory
  );
  const isGuest = useSelector((state) => state.userInfo.isGuest);
  const { productName } = useProductInfo(
    t,
    galleryItemType === "setting"
      ? itemDetail?.type
      : galleryItemType === "stone"
      ? stoneItemDetail?.type
      : matchingPairItemDetail?.type,
    itemDetail,
    isCustomApp
  );
  const { sizes } = getComponentDimentions(theme, height, width);

  useEffect(() => {
    const showListener = Keyboard.addListener("keyboardDidShow", () => {
      setKeyboardVisible(true);
    });

    const hideListener = Keyboard.addListener("keyboardDidHide", () => {
      setKeyboardVisible(false);
    });

    return () => {
      showListener.remove();
      hideListener.remove();
    };
  }, []);

  useEffect(() => {
    if (route?.params?.itemDetail) {
      setItemDetail({});
      setItemDetail(route?.params?.itemDetail);
    }
    if (route?.params?.stoneItemDetail) {
      setStoneItemDetail({});
      setStoneItemDetail(route?.params?.stoneItemDetail);
    }
    if (route?.params?.matchingPairItemDetail) {
      setMatchingPairItemDetail({});
      setMatchingPairItemDetail(route?.params?.matchingPairItemDetail);
    }
    if (additionalAttributes?.config) {
      jcSelectedOption.current.option_value = additionalAttributes.config;
    }
    if (additionalAttributes?.personalization) {
      setPersonalization(additionalAttributes.personalization);
    }
  }, [route?.params?.itemDetail, route?.params?.stoneItemDetail]);

  useEffect(() => {
    navigation.setOptions({
      headerStyle: {
        borderBottomColor: !userInfo.userCanSetMarkupInOrangeMode()
          ? theme[getPriceModeColorCode(priceMode)]
          : theme["core-04"],
        borderBottomWidth:
          userInfo.userCanSetMarkupInOrangeMode() ||
          priceMode === PriceModes.WHITE
            ? 1
            : 4,
        backgroundColor: background
          ? theme[background as keyof DefaultTheme]
          : theme["core-03"],
      },
    });
    setShowProductHeaderStickySummary(false);
  }, [priceMode]);

  useEffect(() => {
    setBottomButtons(
      getReviewPageButtons({
        fromRequest: !!fromRequest,
        fromOrderCart: !!fromOrderCart,
        pdpLayout,
        product_type,
        theme,
        priceMode,
        showBulkRequest,
        showOrderCartButton,
        itemDetail,
        stoneItemDetail,
        matchingPairItemDetail,
        setReviewTotalPrice,
        userInfo,
      })
    );
  }, [
    pdpLayout,
    priceMode,
    itemDetail,
    fromRequest,
    fromOrderCart,
    showBulkRequest,
    showOrderCartButton,
    product_type,
    stoneItemDetail,
  ]);

  const productAlphaColor = getProductAlphaColor(product_type);

  const insets = useSafeAreaInsets();

  const [customOptions, setCustomOptions] = useState<CustomtOption[]>([]);

  const hide_personalization_section_on_review_screen = useSelector(
    (state: any) =>
      state.globalData?.app_settings
        ?.hide_personalization_section_on_review_screen ?? false
  );

  const sectionLayout = useGetPdpSectionLayout(PdpSections.MEDIA, product_type);
  const commentsLayout = useGetPdpSectionLayout(
    PdpSections.COMMENTS,
    product_type
  );
  const showCommentSection = commentsLayout?.price_modes?.includes(priceMode);

  const stonePriceDisclaimerLayout = useGetPdpSectionLayout(
    PdpSections.PRICE_DISCLAIMER,
    stoneItemDetail?.type
  );

  const settingPriceDisclaimerLayout = useGetPdpSectionLayout(
    PdpSections.PRICE_DISCLAIMER,
    itemDetail?.type
  );

  const priceDisclaimerLayout =
    settingPriceDisclaimerLayout && !Array.isArray(settingPriceDisclaimerLayout)
      ? settingPriceDisclaimerLayout
      : stonePriceDisclaimerLayout && !Array.isArray(stonePriceDisclaimerLayout)
      ? stonePriceDisclaimerLayout
      : null;

  const personalizationSectionLayout = useGetPdpSectionLayout(
    PdpSections.PERSONALIZATION,
    product_type
  );
  const successPopUpcConfig =
    pdpLayout[product_type]?.review_page?.add_to_cart_popUp;
  const showPersonalizationSection =
    personalizationSectionLayout?.price_modes?.includes(priceMode) &&
    !hide_personalization_section_on_review_screen;

  const reviewPageSectionsConfig = useGetReviewPageSectionsOrder(product_type);
  const visibleSections = useMemo(
    () => getVisibleReviewPageSections(reviewPageSectionsConfig, priceMode),
    [reviewPageSectionsConfig, priceMode]
  );

  useEffect(() => {
    if (
      sectionLayout?.sub_section &&
      typeof sectionLayout.sub_section === "object"
    ) {
      const subSections = Object.values(sectionLayout.sub_section);

      const filteredOptions = subSections
        .filter(
          (subSection) =>
            Array.isArray(subSection.price_modes) &&
            subSection.price_modes.includes(priceMode)
        )
        .sort((a, b) => (a.order || 0) - (b.order || 0));

      setCustomOptions(filteredOptions);
    } else {
      setCustomOptions([]);
    }
  }, [sectionLayout, priceMode]);

  useEffect(() => {
    if (galleryItemType !== "setting") {
      toggleGalleryItem("setting");
    }
  }, [userSelectedSlug]);

  useEffect(() => {
    if (!isFocused) return;
    const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0;

    const parseStored = (raw: string | null) => {
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        return parsed && Object.keys(parsed).length > 0 ? parsed : null;
      } catch {
        return null;
      }
    };

    const storedStone =
      Platform.OS === "web"
        ? parseStored(localStorage.getItem("stoneItemDetails"))
        : null;
    const storedItem =
      Platform.OS === "web"
        ? parseStored(localStorage.getItem("itemDetail"))
        : null;
    const hasStorageBuilderData = !!storedStone && !!storedItem;

    // The in-memory builder context is the source of truth for rendering. If
    // localStorage is ever out of sync with the context (e.g. after navigating
    // back through breadcrumbs), the context can still hold valid stone +
    // setting data. Treat that as valid so completing the flow
    // (Add to Jewelry -> review) doesn't wrongly bounce to search.
    const hasContextBuilderData =
      !!mItemDetail &&
      Object.keys(mItemDetail).length > 0 &&
      !!mStoneItemDetail &&
      Object.keys(mStoneItemDetail).length > 0;

    if (
      Platform.OS === "web" &&
      !hasContextBuilderData &&
      hasStorageBuilderData
    ) {
      setStoneItemDetail(storedStone);
      setItemDetail(storedItem);
      const storedMatchingPair = parseStored(
        localStorage.getItem("matchingPairItemDetails")
      );
      if (storedMatchingPair) {
        setMatchingPairItemDetail(storedMatchingPair);
      }
      return;
    }

    const shouldRedirect =
      Platform.OS === "web"
        ? !hasStorageBuilderData && !hasContextBuilderData
        : !mItemDetail ||
          isEmptyObject(mItemDetail) ||
          !mStoneItemDetail ||
          isEmptyObject(mStoneItemDetail);

    if (
      shouldRedirect &&
      !route?.params?.itemDetail &&
      !route?.params?.stoneItemDetail
    ) {
      clearRouteHistory();
      const productType = userInfo.defaultStockItemType();
      const targetScreen =
        theme.isTablet || theme.isLargeScreen
          ? Routes.FilterSplitScreen
          : Routes.SearchResultScreen;

      navigation.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [
            {
              name: Routes.AppNavigator,
              state: {
                index: 0,
                routes: [
                  {
                    name: Routes.ExploreNavigator,
                    state: {
                      index: 0,
                      routes: [
                        {
                          name: targetScreen,
                          params: {
                            productType: productType,
                            productPrefix: getProductPrefix(
                              productType as ProductCategory
                            ),
                          },
                        },
                      ],
                    },
                  },
                ],
              },
            },
          ],
        })
      );
    }
  }, [isFocused]);

  const getFilterDetailData = (searchText: string): any => {
    const filteredArray = customOptions.filter(
      (item) => item.name === searchText
    );

    return filteredArray.length === 0 ? true : false;
  };
  const isCertificateShow = getFilterDetailData("certificate");

  const receivedDiamondData = useMemo(() => {
    if (isDiamondOrLabGrown(product_type)) {
      const filteredMedia = filterInvalidMedia(
        galleryItemType === "setting"
          ? itemDetail?.media
          : galleryItemType === "stone"
          ? stoneItemDetail?.media
          : matchingPairItemDetail?.media
      );
      return isCertificateShow
        ? filterCertificate(filteredMedia)
        : filteredMedia;
    } else if (isGemstone(product_type)) {
      const filteredMedia = filterInvalidMedia(
        galleryItemType === "setting"
          ? itemDetail?.media
          : galleryItemType === "stone"
          ? stoneItemDetail?.media
          : matchingPairItemDetail?.media
      );
      return isCertificateShow
        ? filterCertificate(filteredMedia)
        : filteredMedia;
    } else if (isJewelry(product_type)) {
      const filteredMedia = filterInvalidMedia(
        galleryItemType === "setting"
          ? itemDetail?.media
          : galleryItemType === "stone"
          ? stoneItemDetail?.media
          : matchingPairItemDetail?.media
      );
      if (
        filteredMedia &&
        Array.isArray(filteredMedia) &&
        itemDetail?.three_d_enabled
      ) {
        filteredMedia.unshift({
          type: MediaType.MODEL_3D,
          link: process.env.EXPO_PUBLIC_THREE_D_IFRAME_URL,
          thumb: "",
          order: 1,
        });
      }
      return isCertificateShow
        ? filterCertificate(filteredMedia)
        : filteredMedia;
    }
    return [];
  }, [
    product_type,
    isCertificateShow,
    itemDetail,
    stoneItemDetail,
    galleryItemType,
  ]);

  const productColor = getProductColor(product_type);

  useEffect(() => {
    if (!(Platform.OS === "web" && !theme.isMobile)) {
      handleReset();
    }
  }, [isFocused]);

  const { BottomButtonView, toggleModal, handleBottomButtonActions } =
    PdpBottomButtons({
      bottomButtons,
      route,
      product_type,
      disabledMemo: false,
      addToJewelryMenu: false,
      setAddToJewelryMenu: () => {},
      getAddToJewelryOptionsData: () => {},
      setModals,
      setSelectedTabSlideSheet,
      priceMode,
      checkAllFieldsEntered: () => {},
      addToCart,
      itemQuantity: 1,
      enterSecondFlow: true,
      fromReviewPage: true,
      enableJewelryBuilder: enableJewelryBuilder,
      itemDetail,
      stoneItemDetail,
      fromRequest: false,
      fromOrderCart: false,
      matchingPairItemDetail,
      checkItemAvailability,
    });

  const navigateToRequest = () => {
    const popNavigation = () => {
      return new Promise<void>((resolve, reject) => {
        try {
          toggleModal("showRequestSuccessPopUp", false);
          resolve();
        } catch (error) {
          console.error("Error while navigating back:", error);
          reject(error);
        }
      });
    };

    popNavigation()
      .then(() => {
        dispatch(resetFiltersPayload());
        clearRouteHistory();
        resetDefaultSlug(true);
        setItemDetail({});
        setStoneItemDetail({});
        setMatchingPairItemDetail({});
        if (Platform.OS === "web") {
          localStorage.removeItem("stoneItemDetails");
          localStorage.removeItem("itemDetails");
        }
        const navigateParams = {
          selectedTab: "sent",
          initial: false,
          requestedItem: requestData,
          screen: Routes.RequestDetailScreen,
          params: {
            id: requestData?.id,
            selectedTab: "sent",
            requestName: false,
            productType: product_type ?? ProductCategory.DEFAULT,
            price_mode: priceMode,
          },
        };
        navigate(Routes.AppNavigator, {
          screen: Routes.RequestHistoryNavigator,
          params: navigateParams,
        });
      })
      .catch((error) => {
        console.error("Failed to complete navigation:", error);
      });
  };

  const navigateToOrder = () => {
    const popNavigation = () => {
      return new Promise<void>((resolve, reject) => {
        try {
          toggleModal("showAddToCartSuccessPopUp", false);
          resolve();
        } catch (error) {
          console.error("Error while navigating back:", error);
          reject(error);
        }
      });
    };

    popNavigation()
      .then(() => {
        dispatch(resetFiltersPayload());
        if (history.length > 0) {
          navigation.pop(history.length);
        }
        clearRouteHistory();
        resetDefaultSlug(true);
        setItemDetail({});
        setStoneItemDetail({});
        setMatchingPairItemDetail({});
        if (Platform.OS === "web") {
          localStorage.removeItem("stoneItemDetails");
          localStorage.removeItem("itemDetails");
        }
        navigate(Routes.BulkRequestNavigator, {
          screen: Routes.OrderCartScreen,
        });
      })
      .catch((error) => {
        console.error("Failed to complete navigation:", error);
      });
  };

  const navigateToDeeplink = (deeplink?: string, forOrderCart?: boolean) => {
    const popNavigation = () => {
      return new Promise<void>((resolve, reject) => {
        try {
          forOrderCart
            ? toggleModal("showAddToCartSuccessPopUp", false)
            : toggleModal("showRequestSuccessPopUp", false);
          resolve();
        } catch (error) {
          console.error("Error while navigating back:", error);
          reject(error);
        }
      });
    };

    popNavigation()
      .then(() => {
        dispatch(resetFiltersPayload());
        if (history.length > 0) {
          navigation.pop(history.length);
        }
        clearRouteHistory();
        resetDefaultSlug(true);
        setItemDetail({});
        setStoneItemDetail({});
        setMatchingPairItemDetail({});
        if (Platform.OS === "web") {
          localStorage.removeItem("stoneItemDetails");
          localStorage.removeItem("itemDetails");
        }
        if (deeplink) {
          RedirectFunc(deeplink, linkTo);
        } else {
          navigate(Routes.ExploreNavigator, {
            screen: Routes.Explore,
            initial: true,
          });
        }
      })
      .catch((error) => {
        console.error("Failed to complete navigation:", error);
      });
  };
  const actionMap = {
    go_to_cart: navigateToOrder,
    go_to_deeplink: (deeplink: string) => navigateToDeeplink(deeplink, true),
  };

  const transformedButtons = successPopUpcConfig
    ? successPopUpcConfig?.buttons?.map((btn) => {
        if (btn.onPressAction === "go_to_deeplink" && btn.deeplink) {
          return {
            ...btn,
            title: t(btn.title),
            onPressAction: () => actionMap.go_to_deeplink(btn.deeplink),
          };
        }

        return {
          ...btn,
          title: t(btn.title),
          onPressAction: actionMap?.[btn.onPressAction] || (() => {}),
        };
      })
    : [];

  const textComment = getProductProperty(itemDetail?.item_comment, "") || "";
  const stickyContainerHeight = theme.isMobile
    ? itemDetail?.custom_design_configuration &&
      itemDetail?.display_configuration_v2
      ? 250 + (1 + 8 + 20 + 8 + 1) + (8 + 20 + 8) //250 for image, 1 for border, 8 for padding, 20 for title
      : 88.5
    : priceMode === PriceModes.GREEN || itemDetail?.custom_design_configuration
    ? 20 + 8 + 20 + 16 + 1 + 1 + 16 + 16 + 16 // 20 is the height of the stock hash, 20 for short title, 8px are paddings between section, 16px is padding around section, 16px is the padding below section, 16px is the padding above.
    : 20 + 8 + 20 + 8 + 16.5 + 16 + 1 + 1 + 16 + 16 + 16; // 20 is the height of the stock hash, 20 for short title, 16.5 for total price,  8px are paddings between section, 16px is padding around section, 16px is the padding below section, 16px is the padding above.

  const { width: screenWidth, height: screenHeight } = Dimensions.get("window");
  const AdaptiveContainer =
    (theme.isMobile || theme.isTablet) && Platform.OS !== "web"
      ? React.Fragment
      : KeyboardAwareScrollView;
  const AdaptiveContainerTablet =
    (theme.isMobile || theme.isTablet) && Platform.OS !== "web"
      ? KeyboardAwareScrollView
      : Animated.ScrollView;

  const handleLayoutPDP = (event: any) => {
    const { width: layoutWidth } = event.nativeEvent.layout;
    setRightComponentWidth(layoutWidth);
  };

  const onViewScroll = () => {
    headerProductView.current?.measure(
      (
        __: number,
        ___: number,
        ____: number,
        _____: number,
        ______: number,
        headerProductViewPosition: number
      ) => {
        headerStickySummaryViewRef.current?.measure(
          (
            _______: number,
            ________: number,
            _________: number,
            __________: number,
            ___________: number,
            headerStickySummaryViewPosition: number
          ) => {
            if (
              headerProductViewPosition - headerStickySummaryViewPosition >
              stickyContainerHeight
            ) {
              setShowProductHeaderStickySummary(false);
            } else if (
              headerProductViewPosition - headerStickySummaryViewPosition <=
              stickyContainerHeight
            ) {
              setShowProductHeaderStickySummary(true);
            }
          }
        );
      }
    );
  };

  const refundPolicyLayout = useGetPdpSectionLayout(
    PdpSections.REFUND_POLICY,
    product_type
  );

  const showRefundPolicy = useMemo(
    () => refundPolicyLayout?.price_modes?.includes(priceMode) ?? false,
    [refundPolicyLayout, priceMode]
  );

  const renderersProps = useMemo(
    () => ({
      a: {
        onPress(...args: any[]) {
          const href = args[1];
          if (href && Platform.OS !== "web") {
            const deepLink = replaceDeeplinkScheme(
              href,
              process.env.EXPO_PUBLIC_APP_SCHEME
            );
            Linking.openURL(deepLink);
          } else {
            Linking.canOpenURL(href).then(() => {
              Linking.openURL(href);
            });
          }
        },
      },
    }),
    []
  );

  const onScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      jsScrollHandler(event);
      onViewScroll();
    },
    [
      stickyContainerHeight,
      headerProductView.current,
      headerStickySummaryViewRef.current,
    ]
  );
  const showBreadCrumbInMobile =
    enableJewelryBuilder && history.length >= 2 && theme.isMobile;

  const renderReviewComponent = (componentName: string) => {
    switch (componentName) {
      case PdpComponentNames.STONE_CARD:
        return (
          <StoneCard
            key={componentName}
            stoneItemDetail={stoneItemDetail}
            priceMode={priceMode}
            toggleGalleryItem={toggleGalleryItem}
            matchingPair={false}
            fromRequest={fromRequest || fromOrderCart}
            selectedType={
              galleryItemType === "stone"
                ? stoneItemDetail?.id
                : galleryItemType === "setting"
                ? itemDetail?.id
                : matchingPairItemDetail?.id
            }
            type="stone"
            isFirstBreadcrumbStoneDetailPage={isFirstBreadcrumbStoneDetailPage}
            startFromStone={startFromStone}
          />
        );
      case PdpComponentNames.MATCHING_STONE_CARD:
        return matchingPairItemDetail &&
          Object.keys(matchingPairItemDetail).length > 0 ? (
          <StoneCard
            key={componentName}
            stoneItemDetail={matchingPairItemDetail}
            priceMode={priceMode}
            toggleGalleryItem={toggleGalleryItem}
            fromRequest={fromRequest || fromOrderCart}
            matchingPair={true}
            selectedType={
              galleryItemType === "stone"
                ? stoneItemDetail?.id
                : galleryItemType === "setting"
                ? itemDetail?.id
                : matchingPairItemDetail?.id
            }
            type="matchingStone"
            startFromStone={startFromStone}
          />
        ) : null;
      case PdpComponentNames.SETTING_CARD:
        return (
          <SettingCard
            key={componentName}
            settingItemDetails={itemDetail}
            toggleGalleryItem={toggleGalleryItem}
            fromRequest={fromRequest || fromOrderCart}
            selectedType={
              galleryItemType === "stone"
                ? stoneItemDetail?.id
                : galleryItemType === "setting"
                ? itemDetail?.id
                : matchingPairItemDetail?.id
            }
            type="setting"
            isFirstBreadcrumbJewelryDetailPage={
              isFirstBreadcrumbJewelryDetailPage
            }
            startFromSetting={startFromSetting}
          />
        );
      case PdpComponentNames.JEWELRY_CONFIGURATOR:
        return itemDetail?.display_configuration_v2 &&
          itemDetail?.custom_design_configuration ? (
          <JewelryConfiguratorComponents
            key={componentName}
            displayConfigurationV2={allTypes}
            productType={product_type}
            maxWidth={rightComponentWidth}
            fromReviewPage={true}
            fromOrderCart={fromOrderCart}
            fromRequest={fromRequest}
            enterSecondFlow={true}
            updateJewelryConfigInfo={updateJewelryConfigInfo}
          />
        ) : null;
      case PdpComponentNames.PRODUCT_DETAILS:
        return (
          <ProductDetailExpand
            key={componentName}
            itemDetail={itemDetail}
            isJewelry={isJewelry(product_type)}
            isDiamond={isDiamond(product_type)}
            isGemstone={isGemstone(product_type)}
            isProductDetail={true}
            isLabgrown={isLabGrown(product_type)}
            title={t("productDetailPage.productDetails.text")}
            productColor={productColor}
            isPdpScreen={true}
            productType={product_type}
          />
        );
      case PdpComponentNames.PERSONALIZATION:
        return showPersonalizationSection ? (
          <Personalization
            key={componentName}
            productType={product_type}
            title={t(personalizationSectionLayout?.label)}
            sub_options={personalizationSectionLayout["sub-sections"]}
            engravable={itemDetail.engravable}
            disabled={fromRequest || fromOrderCart}
            onMultilineFocusChange={setIsMultilineFocused}
          />
        ) : null;
      case PdpComponentNames.PRICE_DISCLAIMER:
        return (
          <PriceDisclaimer
            key={componentName}
            config={priceDisclaimerLayout}
            spacing={sizes.spacing}
            productType={itemDetail?.type}
            priceMode={priceMode}
          />
        );
      case PdpComponentNames.COMMENTS:
        return (
          Object.keys(commentsLayout)?.length > 0
            ? showCommentSection
            : priceMode === PriceModes.WHITE
        ) ? (
          <ViewContainer isGem={isGemstone(product_type)}>
            <Spacer size={SpaceType.Double} />
            <CollapsibleView
              initExpanded={true}
              title={t("productDetailPage.comments.text")}
              arrowStyling={{
                color: theme["core-04"],
              }}
              applyShadow
            >
              <Divider />
              <TextContainer>
                <RenderHTML
                  contentWidth={width}
                  defaultTextProps={{
                    selectable: true,
                  }}
                  source={{ html: textComment }}
                  tagsStyles={{
                    body: typography["Body-R"],
                  }}
                />
              </TextContainer>
            </CollapsibleView>
          </ViewContainer>
        ) : null;
      case PdpComponentNames.REFUND_POLICY:
        return showRefundPolicy && refundPolicyLayout?.text ? (
          <>
            <RenderHTML
              contentWidth={width}
              defaultTextProps={{ selectable: true }}
              source={{
                html: t(refundPolicyLayout?.text),
              }}
              tagsStyles={{
                body: {
                  ...typography["Body-R"],
                  color: theme["core-06"],
                },
              }}
              renderersProps={renderersProps}
            />
            <Spacer size={SpaceType.large + SpaceType.ExtraSmall} />
          </>
        ) : null;
      default:
        return null;
    }
  };

  return (
    <ThreeDPropertiesProvider>
      {itemDetail && Object.keys(itemDetail).length > 0 ? (
        <View
          style={{
            width: "100%",
            flex: 1,
            alignSelf: "center",
            backgroundColor:
              theme[`${getProductThemeFromType(product_type)}-01`],
          }}
        >
          <LayoutContainer>
            {showBreadCrumbInMobile && (
              <BreadCrumbContainerMobile>
                <Breadcrumbs />
              </BreadCrumbContainerMobile>
            )}
            {theme.isMobile && !isKeyboardVisible ? (
              <ParentStickyPriceContainerMobile
                ref={headerStickySummaryViewRef}
                topMargin={showBreadCrumbInMobile ? 48 : 0}
              >
                <StickyPriceChildContainerMobile
                  showProductHeaderStickySummary={
                    showProductHeaderStickySummary
                  }
                >
                  <StickyPriceContainer
                    isGuest={isGuest}
                    theme={theme}
                    productColor={productColor}
                    itemDetail={
                      galleryItemType === "setting"
                        ? itemDetail
                        : galleryItemType === "stone"
                        ? stoneItemDetail
                        : matchingPairItemDetail
                    }
                    priceMode={priceMode}
                    productType={product_type}
                    showAvailabilityDot={showAvailabilityDot}
                    productName={productName}
                    productAlphaColor={productAlphaColor}
                    activeIndex={mediaActiveIndex}
                    setStickyHeaderActiveIndex={setStickyHeaderActiveIndex}
                    showProductHeaderStickySummary={
                      showProductHeaderStickySummary
                    }
                  />
                </StickyPriceChildContainerMobile>
              </ParentStickyPriceContainerMobile>
            ) : null}
            {theme.isTablet && (
              <View
                style={{
                  backgroundColor: theme["core-01"],
                  borderBottomColor: theme["core-03"],
                  borderBottomWidth: 1,
                }}
              >
                <Breadcrumbs />
              </View>
            )}
            <AdaptiveContainer
              enableOnAndroid
              extraScrollHeight={Platform.OS === "android" ? 50 : 0}
              keyboardShouldPersistTaps="handled"
              enableAutomaticScroll
              enableResetScrollToCoords={false}
              contentContainerStyle={{ flexGrow: 1 }}
              onScroll={onScroll}
              scrollEventThrottle={16}
              style={{
                flex: 1,
                backgroundColor: theme["core-02"],
                ...(showBreadCrumbInMobile && { paddingTop: 50 }),
              }}
              extraHeight={theme.isMobile ? 75 : 0}
            >
              <MainContainer>
                <Container
                  maxWidth={
                    theme.isTablet && screenHeight < 775
                      ? 900
                      : theme.isLargeScreen && height > 720
                      ? maxContentLength
                      : 1008
                  }
                  noPadding
                >
                  {theme.isLargeScreen && <Breadcrumbs />}
                  <ViewContainer
                    onLayout={handleLayout}
                    isGem={isGemstone(product_type)}
                  >
                    <RowViews>
                      <CenterView>
                        <RowView>
                          {!theme.isMobile && (
                            <FixedGalleryView>
                              <FixedSetGalleryView>
                                <FixedContentGalleryView>
                                  <PDPGalleryView
                                    ReceivedDiamondData={receivedDiamondData}
                                    itemDetail={
                                      galleryItemType === "setting"
                                        ? itemDetail
                                        : galleryItemType === "stone"
                                        ? stoneItemDetail
                                        : matchingPairItemDetail
                                    }
                                    productType={product_type}
                                    screenWidth={screenWidth}
                                    imageWidth={
                                      theme.isLargeScreen
                                        ? sizes.imageWidth
                                        : Math.max(0, contentWidth - 474)
                                    }
                                    dimensions={sizes}
                                    showExpandButton
                                    setMediaActiveIndex={setMediaActiveIndex}
                                    mediaActiveIndex={mediaActiveIndex}
                                    fromReviewPage={true}
                                  />
                                </FixedContentGalleryView>
                              </FixedSetGalleryView>
                            </FixedGalleryView>
                          )}
                          <RowContainer>
                            <>
                              <WidthContainer>
                                <AdaptiveContainerTablet
                                  enableOnAndroid
                                  extraScrollHeight={
                                    theme.isTablet
                                      ? isMultilineFocused
                                        ? 150
                                        : 100
                                      : 50
                                  }
                                  enableAutomaticScroll={true}
                                  keyboardShouldPersistTaps="handled"
                                  keyboardDismissMode="interactive"
                                  onScroll={onScroll}
                                  enableResetScrollToCoords={false}
                                  scrollEventThrottle={16}
                                  extraHeight={theme.isMobile ? 75 : 0}
                                  style={{
                                    ...(showBreadCrumbInMobile && {
                                      paddingTop: 50,
                                    }),
                                  }}
                                >
                                  {theme.isMobile && (
                                    <View style={{ flex: 1 }}>
                                      <PDPGalleryView
                                        ReceivedDiamondData={
                                          receivedDiamondData
                                        }
                                        itemDetail={
                                          galleryItemType === "setting"
                                            ? itemDetail
                                            : galleryItemType === "stone"
                                            ? stoneItemDetail
                                            : matchingPairItemDetail
                                        }
                                        productType={product_type}
                                        screenWidth={screenWidth}
                                        imageWidth={contentWidth}
                                        fromReviewPage={true}
                                        setMediaActiveIndex={
                                          setMediaActiveIndex
                                        }
                                        mediaActiveIndex={
                                          stickyHeaderActiveIndex
                                        }
                                      />
                                    </View>
                                  )}
                                  <ParentViewContainer
                                    onLayout={handleLayoutPDP}
                                    ref={headerProductView}
                                  >
                                    <Spacer size={sizes.spacing} />
                                    <ViewContainer
                                      isGem={isGemstone(product_type)}
                                    >
                                      <ReviewHeaderDetails
                                        stoneItemDetail={stoneItemDetail}
                                        itemDetail={itemDetail}
                                        matchingPairItemDetail={
                                          Object.keys(
                                            matchingPairItemDetail || {}
                                          ).length === 0
                                            ? undefined
                                            : matchingPairItemDetail
                                        }
                                      />
                                      {visibleSections.map(
                                        (componentName, index) => {
                                          const component =
                                            renderReviewComponent(
                                              componentName
                                            );
                                          if (!component) return null;
                                          return (
                                            <React.Fragment key={componentName}>
                                              {component}
                                              {index <
                                                visibleSections.length - 1 && (
                                                <Spacer
                                                  size={SpaceType.Double}
                                                />
                                              )}
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </ViewContainer>
                                    <Spacer size={SpaceType.Size_80} />
                                  </ParentViewContainer>
                                </AdaptiveContainerTablet>
                              </WidthContainer>
                            </>
                          </RowContainer>
                        </RowView>
                      </CenterView>
                    </RowViews>
                  </ViewContainer>

                  {Platform.OS === "ios" && <FooterSpace insets={insets} />}
                </Container>
                <BMHModal
                  isOpen={modals.showBMHModal}
                  onClose={() => toggleModal("showBMHModal", false)}
                  title={"reviewPage.placeBuyRequest.modal.title.text"}
                  itemDetail={itemDetail}
                  initialSelectedOption={selectedTabSlideSheet}
                  productType={product_type ?? ProductCategory.DEFAULT}
                  externalPriceMode={priceMode}
                  fromReviewPage={true}
                  setRequestData={setRequestData}
                  toggleModal={toggleModal}
                  modals={modals}
                  navigateToDeeplink={navigateToDeeplink}
                  navigateToRequest={navigateToRequest}
                />
                <AskSupplierModal
                  isOpen={modals.showAskSupplierModal}
                  onClose={() => toggleModal("showAskSupplierModal", false)}
                  itemDetail={itemDetail}
                  onSuccess={() => toggleModal("showSuccessPopup", true)}
                  fromReviewPage={true}
                />
                <ConfirmationPopup
                  title={t("askSupplier.popUp.title.text")}
                  htmlMessage={t("askSupplier.popUp.discription.text")}
                  primaryButtonTitle={t("askSupplier.popUp.button.text")}
                  primaryButtonAction={() => {
                    toggleModal("showSuccessPopup", false);
                  }}
                  category={
                    itemDetail?.type === "diamond"
                      ? ButtonCategory.diam
                      : itemDetail?.type === "gemstone"
                      ? ButtonCategory.gem
                      : itemDetail?.type === "jewelry"
                      ? ButtonCategory.jewelry
                      : ButtonCategory.lab
                  }
                  messageType={messageType.Success}
                  colorKey={"core-05"}
                  opened={modals.showSuccessPopup}
                />
                <ConfirmationPopup
                  title={t("askSupplier.popUp.title.text")}
                  htmlMessage={t("askSupplier.popUp.discription.text")}
                  primaryButtonTitle={t("askSupplier.popUp.button.text")}
                  primaryButtonAction={() => {
                    toggleModal("showSuccessPopup", false);
                  }}
                  category={
                    itemDetail?.type === "diamond"
                      ? ButtonCategory.diam
                      : itemDetail?.type === "gemstone"
                      ? ButtonCategory.gem
                      : itemDetail?.type === "jewelry"
                      ? ButtonCategory.jewelry
                      : ButtonCategory.lab
                  }
                  messageType={messageType.Success}
                  colorKey={"core-05"}
                  opened={modals.showSuccessPopup}
                />
                <ConfirmationPopup
                  opened={modals.showRequestSuccessPopUp}
                  title={t(
                    "reviewPage.placeBuyRequest.successPopUp.title.text"
                  )}
                  htmlMessage={t(
                    "reviewPage.placeBuyRequest.successPopUp.discription.text"
                  )}
                  primaryButtonTitle={t(
                    "reviewPage.placeBuyRequest.successPopUp.button.product.text"
                  )}
                  secondaryButtonTitle={t(
                    "reviewPage.placeBuyRequest.successPopUp.button.request.text"
                  )}
                  primaryButtonAction={() => {
                    navigateToDeeplink(
                      pdpLayout[product_type]?.review_page?.deeplink_button
                        ?.link
                    );
                  }}
                  secondaryButtonAction={() => {
                    navigateToRequest();
                  }}
                  category={getButtonCategory(itemDetail?.type)}
                  messageType={messageType.Success}
                  primaryButtonType={ButtonType.primary}
                  secondaryButtonType={ButtonType.secondary}
                  styleKey={"Body-R"}
                />
                {modals.showAddToCartSuccessPopUp && (
                  <PopUp
                    title={t(successPopUpcConfig?.title)}
                    buttons={transformedButtons}
                    HtmlSource={{
                      html: t(successPopUpcConfig?.message),
                    }}
                    styleKey={"Body-R"}
                    type={messageType.Success}
                  />
                )}
                <OptionsModal
                  isOpen={modals.showButtonsOptions}
                  onClose={() => toggleModal("showButtonsOptions", false)}
                  options={
                    pdpLayout[product_type]?.review_page?.bottom_buttons?.mobile
                      ?.request_options?.options || {}
                  }
                  onOptionSelect={(optionName) => {
                    toggleModal("showButtonsOptions", false);
                    handleBottomButtonActions(optionName);
                  }}
                  t={t}
                  priceMode={priceMode}
                  title={
                    pdpLayout[product_type]?.review_page?.bottom_buttons?.mobile
                      ?.request_options?.modalTitle
                  }
                />
              </MainContainer>
            </AdaptiveContainer>
            <LineViewContainer background="core-03" marginLeft={false} />
            <ButtonSectionView>
              <ButtonSectionContainer
                maxWidth={
                  theme.isTablet && screenHeight < 775
                    ? 900
                    : theme.isLargeScreen && height > 720
                    ? maxContentLength
                    : 1008
                }
              >
                <ButtonSectionChildContainer>
                  <ButtonsEndContainer>
                    {theme.isMobile &&
                    itemDetail?.custom_design_configuration ? (
                      <PDPBottomTotalPriceSection
                        itemDetail={itemDetail}
                        itemQuantity={1}
                        setQuantity={() => {}}
                        isReviewPage={true}
                        reviewTotalPrice={reviewTotalPrice}
                      />
                    ) : null}

                    {bottomButtons?.length ? (
                      !theme.isMobile ? (
                        <>
                          <LeftButtonWrapper>
                            {bottomButtons[0][0]?.name === "total_price" ? (
                              <PDPBottomTotalPriceSection
                                itemDetail={itemDetail}
                                itemQuantity={1}
                                setQuantity={() => {}}
                                isReviewPage={true}
                                reviewTotalPrice={reviewTotalPrice}
                              />
                            ) : (
                              <BottomButtonView
                                bottomButton={bottomButtons[0][0]}
                              />
                            )}
                          </LeftButtonWrapper>

                          <RightButtonsWrapper>
                            {bottomButtons
                              .flat()
                              .slice(1)
                              .map((bottomButton: any, index: number) =>
                                bottomButton.name === "total_price" ? (
                                  <PDPBottomTotalPriceSection
                                    key={index}
                                    itemDetail={itemDetail}
                                    itemQuantity={1}
                                    setQuantity={() => {}}
                                    isReviewPage={true}
                                    reviewTotalPrice={reviewTotalPrice}
                                  />
                                ) : (
                                  <BottomButtonView
                                    key={index}
                                    bottomButton={bottomButton}
                                  />
                                )
                              )}
                          </RightButtonsWrapper>
                        </>
                      ) : (
                        bottomButtons.map(
                          (bottomButtonSection: any, i: number) => (
                            <ButtonContainer
                              key={i}
                              length={bottomButtonSection.length}
                              description={
                                bottomButtonSection?.length
                                  ? bottomButtonSection[0]?.description
                                  : "bottom_right"
                              }
                            >
                              {bottomButtonSection.map(
                                (bottomButton: any, j: number) =>
                                  bottomButton.name === "total_price" ? (
                                    <PDPBottomTotalPriceSection
                                      key={j}
                                      itemDetail={itemDetail}
                                      itemQuantity={1}
                                      setQuantity={() => {}}
                                      isReviewPage={true}
                                      reviewTotalPrice={reviewTotalPrice}
                                    />
                                  ) : (
                                    <BottomButtonView
                                      key={j}
                                      bottomButton={bottomButton}
                                    />
                                  )
                              )}
                            </ButtonContainer>
                          )
                        )
                      )
                    ) : null}
                  </ButtonsEndContainer>
                </ButtonSectionChildContainer>
              </ButtonSectionContainer>
            </ButtonSectionView>

            {(isAPILoading || addToCart.isLoading) && (
              <Loader backgroundColor={theme["core-02"]} opacity={0.8} />
            )}
          </LayoutContainer>
        </View>
      ) : (
        <Loader />
      )}
    </ThreeDPropertiesProvider>
  );
};

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
  max-width: 100%;
`;

const TextContainer = styled.View`
  padding: 16px;
`;

const FixedGalleryView = styled.View`
  width: 50%;
  height: 100%;
`;

const FixedSetGalleryView = styled.View`
  width: 100%;
  align-self: flex-end;
  position: sticky;
  top: 0;
`;

const WidthContainer = styled.View`
  width: 100%;
`;

const FooterSpace = styled.View<FooterSpaceProps>`
  padding: ${({ insets }) =>
    insets.bottom > 0 ? 10 : Platform.OS === "android" ? 40 : 0}px;
  height: ${({ insets }) =>
    Platform.OS === "ios" ? (insets.bottom > 0 ? 10 : 0) : 10}px;
  background-color: ${({ theme }) => theme["core-02"]};
`;

const ButtonContainer = styled.View<{ length: number; description: string }>`
  flex-direction: row;
  ${({ theme }) =>
    !theme.isMobile
      ? css`
          width: 50%;
          margin: 0 auto;
          gap: ${SpaceType.Extra}px;
          justify-content: ${({ description }) =>
            description === "bottom_right" ? "flex-end" : "flex-start"};
          align-items: center;
        `
      : css`
          width: 100%;
          gap: ${SpaceType.Basic}px;
          align-items: center;
          justify-content: space-between;
          padding-horizontal: ${SpaceType.Basic}px;
        `}
`;

const CenterView = styled.View`
  width: 100%;
`;

const ButtonsEndContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: ${SpaceType.Basic}px;
  ${({ theme }) =>
    !theme.isLargeScreen &&
    Platform.OS === "ios" &&
    css`
      padding-bottom: ${SpaceType.Double}px;
    `}
`;

const LeftButtonWrapper = styled.View`
  flex-direction: row;
  align-items: center;
`;

const RightButtonsWrapper = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${SpaceType.Basic}px;
`;

const RowViews = styled.View`
  align-items: center;
`;

const RowView = styled.View`
  flex-direction: ${({ theme }) => (theme.isMobile ? "column" : "row")};
  gap: ${({ theme }) => (!theme.isMobile ? 30 : 0)}px;
`;

const ViewContainer = styled.View<{ isGem: boolean }>`
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: ${({ isGem }) => (isGem ? 8 : 0)}px;
`;

const FixedContentGalleryView = styled.View<any>`
  width: 100%;
  align-items: flex-end;
  ${({ theme }) =>
    !theme.isTablet
      ? css`
          flex: 1;
        `
      : ""}
`;

const ParentViewContainer = styled.View`
  width: 100%;
  flex-shrink: ${({ theme }) => (theme.isLargeScreen ? 1 : 0)};
  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-left: 10px;
      padding-right: 10px;
    `}
`;

const ButtonSectionView = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  align-items: center;
  justify-content: center;
`;

const ButtonSectionContainer = styled.View<any>`
  ${({ theme }) =>
    !theme.isMobile &&
    css`
      align-items: flex-end;
      justify-content: flex-end;
    `}
  width: ${({ theme }) => (theme.isLargeScreen ? "80%" : "100%")};
  max-width: ${({ maxWidth, theme }) =>
    theme.isMobile ? "100%" : `${maxWidth}px`};
`;

const ButtonSectionChildContainer = styled.View<{
  maxWidth: number;
}>`
  width: 100%;
  max-width: ${({ maxWidth, theme }) =>
    theme.isMobile ? "100%" : `${maxWidth}px`};
`;

const MainContainer = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme["core-02"]};
  align-content: center;
  align-self: center;
  width: ${({ theme }) => (theme.isLargeScreen ? "80%" : "100%")};
`;
const RowContainer = styled.View`
  flex-direction: ${({ theme }) => (theme.isMobile ? "column" : "row")};
  flex: 1;
  flex-basis: auto;
  width: ${({ theme }) => (theme.isMobile ? "100%" : "50%")};
`;

const ParentStickyPriceContainerMobile = styled.View<any>`
  position: absolute;
  top: ${({ topMargin }) => topMargin}px;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  z-index: 100;
  width: 100%;
  background-color: ${({ theme }) => theme["core-01"]};
  box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Gentle)};
`;

const BreadCrumbContainerMobile = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
`;

const StickyPriceChildContainerMobile = styled.View<{
  showProductHeaderStickySummary: boolean;
}>`
  width: 100%;
  display: ${({ showProductHeaderStickySummary }) =>
    showProductHeaderStickySummary ? "block" : "none"};
`;

export default ReviewPage;
